import { Search } from 'lucide-react';
import { forwardRef, useId } from 'react';

import s from './SearchInput.module.css';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Accessible name — rendered as a visually-hidden <label>. */
  label: string;
}

/** A labelled search box with a leading icon, shared across the test-list
 *  views (admin, institute, student) so the look and keyboard/a11y behaviour
 *  stay in one place instead of being copy-pasted per page.
 *
 *  Forwards a ref to the input itself so a page can offer a "/" shortcut —
 *  the alternative is `document.querySelector`, which finds the wrong box the
 *  moment a screen has two. */
export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(function SearchInput(
  { value, onChange, placeholder, label },
  ref,
) {
  const id = useId();
  return (
    <div className={s.root}>
      <Search size={15} className={s.icon} aria-hidden="true" />
      <label className={s.srOnly} htmlFor={id}>
        {label}
      </label>
      <input
        ref={ref}
        id={id}
        type="search"
        className={s.input}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
});
